<template>
  <div>
    <v-dialog v-model="isAditionalTypeOpen" max-width="600" persistent>
      <v-card class="pa-2">
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>Selecione o entregador/transbordo</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="my-2">
          <v-row>
            <v-col cols="12">
              <v-select label="Tipo" v-model="selectedUserType" :items="aditionalUserTypes" hide-details />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                :loading="isTranshipmentsOrDeliveresLoading"
                :label="userSelectLabel"
                v-model="selectedUser"
                :items="transhipmentsOrDeliveres"
                :disabled="!selectedUserType"
                item-text="name"
                return-object
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex px-6">
          <v-btn @click="close" color="red" dark class="flex-grow-1"> Cancelar </v-btn>
          <v-btn
            @click="confirmSelection"
            :disabled="!selectedUser"
            color="info"
            :dark="!!selectedUser"
            class="flex-grow-1"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isAditionalFormOpen" max-width="1200" persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>Novo Adicional {{ aditionalTitle }}</h1>

            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form ref="aditionalForm">
            <v-row class="mt-3">
              <v-col cols="12" md="3" class="py-1">
                <v-select
                  label="Tipo"
                  v-model="aditional.isDiscount"
                  :items="aditionalType"
                  :rules="[rules.aditionalType]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" class="py-1">
                <v-text-field
                  ref="price"
                  label="Valor"
                  v-model="aditional.price"
                  v-money="money"
                  type="text"
                  :rules="[rules.hasPrice]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="py-1">
                <v-text-field
                  ref="stopOrBoarding"
                  :label="stopOrBoardingFieldLabel"
                  item-text="data.id"
                  v-model="boardingOrStopId"
                  :rules="[rules.isValidId]"
                  v-mask="'NNNNNNNN-NNNN-NNNN-NNNN-NNNNNNNNNNNN'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="py-1">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate"
                      label="Data"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="aditional.additionalDate" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" class="py-1">
                <v-select
                  label="Justificativa"
                  v-model="aditional.justification"
                  :items="justifications"
                  :rules="[rules.required]"
                  item-text="name"
                  return-object
                  :disabled="shouldDisableJustification"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" class="py-1">
                <v-text-field
                  ref="nfeNumber"
                  label="Chave da NFE"
                  v-model="aditional.nfeNumber"
                  v-mask="'############################################'"
                  type="text"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="py-1">
                <v-autocomplete
                  label="Remetente"
                  v-model="aditional.senderId"
                  :items="senders"
                  item-text="name"
                  item-value="id"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column justify-center py-1">
                <v-checkbox
                  v-model="aditional.isLink"
                  :disabled="!aditional.isDiscount"
                  label="Avaria operacional"
                  hide-details
                  class="ma-0 pa-0"
                />
                <span v-if="!aditional.isDiscount" class="text-justify"> Somente débitos </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex align-center pt-1">
                <v-text-field label="Observação" v-model="aditional.observation" hide-details></v-text-field>

                <v-btn
                  :disabled="shouldDisableAddButton"
                  class="ml-4 mb-1 align-self-end"
                  color="success"
                  large
                  @click="addAditional"
                >
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <div class="w-100">
            <div class="my-4">
              <h1>Descrição de Adicionais</h1>
            </div>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="aditionalsHeaders"
                  :items="aditionals"
                  :items-per-page="aditionals.length"
                  no-data-text="Nenhum adicional adicionado"
                  hide-default-footer
                >
                  <template v-slot:[`item.boardingId`]="{ item }">
                    <span>
                      {{ getBoardingOrStopId(item.boardingId) }}
                    </span>
                  </template>
                  <template v-slot:[`item.stopId`]="{ item }">
                    <span>
                      {{ getBoardingOrStopId(item.stopId) }}
                    </span>
                  </template>
                  <template v-slot:[`item.additionalDate`]="{ item }">
                    <span>
                      {{ formatDate(item.additionalDate) }}
                    </span>
                  </template>
                  <template v-slot:[`item.isDiscount`]="{ item }">
                    <span>
                      {{ getDiscountText(item.isDiscount) }}
                    </span>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    <span>
                      {{ formatPrice(item.price) }}
                    </span>
                  </template>
                  <template v-slot:[`item.isLink`]="{ item }">
                    <span>
                      {{ getIsLink(item.isLink) }}
                    </span>
                  </template>
                  <template v-slot:[`item.justification`]="{ item }">
                    <span>
                      {{ getJustificationName(item.justification) }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" @click="editAditional(item)" icon color="info" dark>
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" @click="removeAditional(item)" icon color="red" dark>
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Deletar</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions class="d-flex justify-center py-4" style="gap: 5px">
          <v-btn @click="close" color="red" dark class="px-4"> Cancelar </v-btn>
          <v-btn
            @click="createNewAditionals"
            :loading="isCreateButtonLoading"
            :disabled="shouldDisableConfirmButton"
            color="green"
            :dark="!shouldDisableConfirmButton"
            class="px-4"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { VMoney } from 'v-money';
import { mapActions } from 'vuex';
import aditionalUsersType from '@/consts/AditionalUsersType';
import maskPrice from '@/utils/maskPrice';
import MessagesError from '@/components/MessagesError.vue';
import { stringToMoneyMask } from '@/handlers/MoneyHandler.js';
export default {
  components: {
    MessagesError
  },
  props: {
    isOpen: {
      default: false,
      type: Boolean
    }
  },
  directives: { money: VMoney },
  data: () => ({
    errors: [],
    errorsType: 'error',
    error500: null,
    loading: true,
    isCreateButtonLoading: false,
    isTranshipmentsOrDeliveresLoading: false,
    transhipmentsOrDeliveres: [],
    isUserSelected: false,
    isDirectDeliverer: false,
    aditionalType: [
      { text: 'Crédito', value: false },
      { text: 'Débito', value: true }
    ],
    boardingOrStopId: null,
    aditionals: [],
    aditional: {
      isDiscount: null,
      price: null,
      justification: null,
      additionalDate: null,
      observation: null,
      boardingId: null,
      stopId: null,
      isLink: null,
      nfeNumber: null,
      senderId: null
    },
    selectedUser: null,
    selectedUserType: null,
    justifications: [],
    senders: [],
    aditionalUserTypes: [
      { text: 'Entregador direto', value: aditionalUsersType.DIRECT_DELIVERER },
      { text: 'Transbordo', value: aditionalUsersType.TRANSHIPMENT }
    ],
    menu: false,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      aditionalType: (value) => value !== null || 'Campo obrigatório!',
      hasPrice: (value) => {
        return value !== 'R$ 0,00' || 'Campo obrigatório!';
      },
      isValidId: (value) => {
        if (value === null || value === '') {
          return true;
        } else if (value.length === 36 && /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/.test(value)) {
          return true;
        } else {
          return 'ID inválido!';
        }
      }
    }
  }),

  computed: {
    aditionalsHeaders() {
      return [
        {
          value: this.isDirectDeliverer ? 'boardingId' : 'stopId',
          text: this.isDirectDeliverer ? 'ID DO EMBARQUE' : 'ID DA PARADA',
          sortable: false
        },
        {
          value: 'isDiscount',
          text: 'TIPO',
          sortable: false
        },
        {
          value: 'price',
          text: 'VALOR',
          sortable: false
        },
        {
          value: 'additionalDate',
          text: 'DATA',
          sortable: false
        },
        {
          value: 'isLink',
          text: 'AVARIA',
          sortable: false
        },
        {
          value: 'nfeNumber',
          text: 'NFE',
          sortable: false
        },
        {
          value: 'justification',
          text: 'JUSTIFICATIVA',
          sortable: false
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO',
          sortable: false
        },
        {
          value: 'actions',
          sortable: false,
          align: 'end',
          text: ''
        }
      ];
    },
    formattedDate() {
      const date = this.aditional.additionalDate;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    isAditionalTypeOpen() {
      return this.isOpen && !this.isUserSelected;
    },
    isAditionalFormOpen() {
      return this.isOpen && this.isUserSelected;
    },
    userSelectLabel() {
      if (this.selectedUserType) {
        return this.isDirectDeliverer ? 'Entregador direto' : 'Transbordo';
      } else {
        return 'Selecione um tipo';
      }
    },
    stopOrBoardingFieldLabel() {
      return this.isDirectDeliverer ? 'ID do embarque' : 'ID da parada';
    },
    aditionalTitle() {
      const labels = {
        [aditionalUsersType.DIRECT_DELIVERER]: 'Entregador',
        [aditionalUsersType.TRANSHIPMENT]: 'Transbordo'
      };
      return this.selectedUser !== null ? ` - ${labels[this.selectedUserType]} ${this.selectedUser.name}` : '';
    },
    shouldDisableAddButton() {
      const { isDiscount, price, additionalDate, justification } = this.aditional;
      const hasValidId =
        this.boardingOrStopId !== null &&
        this.boardingOrStopId.length === 36 &&
        /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/.test(this.boardingOrStopId);
      return (
        isDiscount === null ||
        this.transformPriceToSend(price) === 0 ||
        additionalDate === null ||
        justification === null ||
        (this.boardingOrStopId === null || this.boardingOrStopId === '' ? false : !hasValidId)
      );
    },
    shouldDisableConfirmButton() {
      return this.aditionals.length === 0;
    },
    shouldDisableJustification() {
      return this.aditional.isDiscount === null;
    },
    justificationsNumber() {
      return this.aditional.isDiscount ? 11 : 10;
    }
  },

  watch: {
    selectedUserType: {
      async handler(value) {
        this.selectedUser = null;
        if (value !== null) {
          this.isTranshipmentsOrDeliveresLoading = true;

          if (value === aditionalUsersType.TRANSHIPMENT) {
            this.isDirectDeliverer = false;
            this.transhipmentsOrDeliveres = await this.getTranshipmentForPaymentOrder();
          } else {
            this.isDirectDeliverer = true;
            this.transhipmentsOrDeliveres = await this.getDirectDeliverersForPaymentOrder();
          }
          this.isTranshipmentsOrDeliveresLoading = false;
        }
      }
    },

    'aditional.isDiscount': {
      handler(isDiscount, oldIsDiscount) {
        if (oldIsDiscount !== null) {
          this.aditional.justification = null;
        }
        this.handleIsLink(isDiscount);
        this.getAllJustifications();
      }
    },

    isAditionalFormOpen: {
      handler(isOpen) {
        if (isOpen) {
          this.$nextTick(() => {
            if (this.$refs['aditionalForm']) {
              this.$refs.aditionalForm.reset();
            }
          });
        }
      }
    }
  },

  async created() {
    await this.getAllSenders();
  },
  methods: {
    ...mapActions('AccountsStore', [
      'createAditionals',
      'getDirectDeliverersForPaymentOrder',
      'getTranshipmentForPaymentOrder',
      'getSenders'
    ]),

    ...mapActions('NfeStore', ['fetchJustificationsById']),

    async createNewAditionals() {
      try {
        this.isCreateButtonLoading = true;
        const aditionals = {
          applicationUserId: this.selectedUser.aspNetUserId,
          isDirectDeliverer: this.isDirectDeliverer,
          additionalDtos: [...this.aditionals]
        };
        const data = await this.createAditionals(aditionals);

        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.isCreateButtonLoading = false;
      }
    },

    async getAllJustifications() {
      try {
        this.justifications = await this.fetchJustificationsById(this.justificationsNumber);
      } catch (error) {
        console.error(error);
      }
    },

    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },

    handleSuccessFeedback() {
      const hasMoreThanOneAditional = this.aditionals.length > 1;
      this.errors = hasMoreThanOneAditional ? ['Adicionais criados com sucesso!'] : ['Adicional criado com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.close();
    },

    addAditional() {
      const boardingOrStopId = this.boardingOrStopId ? this.boardingOrStopId : null;
      this.aditionals = [
        ...this.aditionals,
        {
          ...this.aditional,
          justification: this.aditional.justification,
          price: this.transformPriceToSend(this.aditional.price),
          boardingId: this.isDirectDeliverer ? boardingOrStopId : null,
          stopId: !this.isDirectDeliverer ? boardingOrStopId : null,
          nfeNumber: this.aditional.nfeNumber ? this.aditional.nfeNumber : null
        }
      ];

      this.resetAditional();
    },

    editAditional(aditional) {
      this.resetAditional();
      let aditionalIndex = this.aditionals.indexOf(aditional);
      const aditionalToEdit = this.aditionals[aditionalIndex];
      this.aditionals.splice(aditionalIndex, 1);
      this.aditional = { ...aditionalToEdit };
      this.boardingOrStopId = this.isDirectDeliverer ? aditionalToEdit.boardingId : aditionalToEdit.stopId;
      this.$refs.price.$el.getElementsByTagName('input')[0].value = stringToMoneyMask(aditionalToEdit.price);
    },

    removeAditional(aditional) {
      const aditionalIndex = this.aditionals.indexOf(aditional);
      this.aditionals.splice(aditionalIndex, 1);
    },

    getBoardingOrStopId(boardingOrStopId) {
      return boardingOrStopId ? boardingOrStopId : ' - ';
    },

    getDiscountText(isDiscount) {
      return isDiscount ? 'Débito' : 'Crédito';
    },

    getIsLink(isLink) {
      return isLink ? 'Sim' : 'Não';
    },

    getJustificationName(justification) {
      return justification !== null ? justification.name : null;
    },

    formatPrice(price) {
      return maskPrice(price);
    },

    formatDate(date) {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },

    handleIsLink(isDiscount) {
      if (!isDiscount) {
        this.aditional.isLink = false;
      }
    },

    resetAditional() {
      this.boardingOrStopId = null;

      if (this.$refs.aditionalForm) {
        this.$refs.price.$el.getElementsByTagName('input')[0].value = 0;
        this.$refs.stopOrBoarding.$el.getElementsByTagName('input')[0].value = null;
        this.$refs.nfeNumber.$el.getElementsByTagName('input')[0].value = null;
        this.$refs.aditionalForm.reset();
      }

      this.aditional = {
        boardingId: null,
        stopId: null,
        isDiscount: null,
        price: null,
        justification: null,
        additionalDate: null,
        observation: null,
        isLink: null,
        nfeNumber: null,
        senderId: null
      };
    },
    reset() {
      this.aditionals = [];
      this.selectedUser = null;
      this.selectedUserType = null;
      this.isUserSelected = false;
      this.resetAditional();
    },
    close() {
      this.reset();
      this.$emit('update:isOpen', false);
    },
    confirmSelection() {
      this.isUserSelected = true;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}
::v-deep .v-input__append-inner.v-input__append-inner .v-input__icon--clear {
  padding-top: 17px;
}
</style>
